// Small display helpers shared by the three commerce screens.

/** `expires_at`/`created_at` are naive-UTC ISO strings with no offset — parse
 *  as UTC explicitly rather than letting `Date` assume local time. */
export function formatDate(isoNaiveUtc: string | null): string | null {
  if (!isoNaiveUtc) return null;
  const date = new Date(`${isoNaiveUtc}Z`);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function formatUsd(value: number | null): string {
  if (value === null) return "unknown";
  return `$${value.toFixed(2)}`;
}
